import { combineReducers } from "redux";
import { authReducer } from "./auth.reducer";
import { teamReducer } from "./team.reducer";
import { playerReducer } from "./player.reducer";
import { statusTrackerReducer } from "./statustracker.reducer";
import { breakdownReducer } from "./breakdown.reducer";
import { drillsReducer } from "./drills.reducer";
import { baselineReducer } from "./baseline.reducer";
import { compareReducer } from "./compare.reducer";
import { calendarReducer } from "./calendar.reducer";
import { dualCalendarReducer } from "./dualcalendar.reducer";
import { managerReducer } from "./manager";
import { settingsReducer } from "./settings.reducer";
import { userDefinedFlagsReducer } from "./userDefinedFlags.reducer";
import { bannerReducer } from "./banner.reducer";
import { notesReducer } from "./notes.reducer";

export default combineReducers({
  auth: authReducer,
  team: teamReducer,
  player: playerReducer,
  statusTracker: statusTrackerReducer,
  breakdown: breakdownReducer,
  drills: drillsReducer,
  baseline: baselineReducer,
  compare: compareReducer,
  calendar: calendarReducer,
  dualCalendar: dualCalendarReducer,
  manager: managerReducer,
  settings: settingsReducer,
  userDefinedFlags: userDefinedFlagsReducer,
  banner: bannerReducer,
  notes: notesReducer
});
